import { useMutation, useQueryClient } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { useListAgencies } from '~/hooks/api/useListAgencies';
import { AGENCY_TOKEN } from '~/queries/keys';

export const useUpdateAgencyEnabledControls = () => {
  const queryClient = useQueryClient();

  const agency = useListAgencies('');

  // typescript v5 update issue
  const agencyId = (agency.data as any)?.results[0].id;

  const mutation = useMutation({
    mutationFn: (enabledControls: string[]) => {
      return clientApi.updateAgencyControls(enabledControls, agencyId);
    },
    onSuccess: async () => {
      queryClient.invalidateQueries([AGENCY_TOKEN]);
      return clientApi.getAgencies('');
    },
  });

  return mutation;
};
